// CAPABILITY: Set/edit the viewer's persistent chat display name.
import React, { useState } from "react";
import { DISPLAY_NAME_MAX_CHARS } from "../chatConfig";
import { validateDisplayNameClient } from "../utils/chatIdentity";

export default function ChatNameModal({ isOpen, initialName = "", onClose, onSubmit, accentColor }) {
  const [name, setName] = useState(initialName);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!isOpen) return null;

  const submit = async (e) => {
    e.preventDefault();
    const check = validateDisplayNameClient(name);
    if (!check.ok) {
      setError(check.reason);
      return;
    }
    setBusy(true);
    setError("");
    const result = await onSubmit(check.value);
    setBusy(false);
    if (result?.ok && result?.name_status === "approved") {
      onClose();
    } else {
      setError(
        result?.reason_message ||
          (result?.name_status === "rejected"
            ? "That name isn't allowed here. Try another."
            : "Couldn't save name. Try again.")
      );
    }
  };

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-slate-950/40 p-4">
      <form onSubmit={submit} className="w-full max-w-xs rounded-xl bg-white p-4 shadow-2xl">
        <h3 className="text-sm font-semibold text-slate-900">Choose a display name</h3>
        <p className="mt-1 text-xs text-slate-500">This is how others see you in the chat.</p>
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value.slice(0, DISPLAY_NAME_MAX_CHARS))}
          maxLength={DISPLAY_NAME_MAX_CHARS}
          placeholder="e.g. Alex"
          className="mt-3 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
        />
        {error && <p className="mt-2 text-xs font-medium text-rose-600">{error}</p>}
        <div className="mt-4 flex justify-end gap-2">
          {initialName && (
            <button type="button" className="rounded-lg px-3 py-2 text-sm text-slate-600 hover:bg-slate-100" onClick={onClose}>
              Cancel
            </button>
          )}
          <button
            type="submit"
            disabled={busy}
            className="rounded-lg px-3 py-2 text-sm font-semibold text-white disabled:opacity-40"
            style={{ backgroundColor: accentColor || "#0f172a" }}
          >
            {busy ? "Saving…" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
